import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { T5Message } from '../interface/t5-message';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
  })
  export class T5MessagesService {
   private _isFromMatrix = true;

    BASE_URL = `${environment.mkgoURL}/api/v1/t5-messages`;

    constructor(
      private dataService: DataService,
      private http: HttpClient
    ) { }
    // messageStatus 1 = não lida, 2 = lida

    async getAll(messageStatus?: number): Promise<T5Message[]> {
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      const url = typeof messageStatus === 'number'
        ? `${this.BASE_URL}?messageStatus=${messageStatus}`
        : this.BASE_URL;
      const resp = await firstValueFrom(
        this.http.get<{t5message: T5Message[]}>(url, header)
      );
      return resp.t5message;
    }

    async markAsRead(messageId: string): Promise<any> {
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      return firstValueFrom(
        this.http.put(`${this.BASE_URL}/${messageId}`, { messageStatus: 2 }, header)
      );
    }
  }
